import { Component, Emit, Vue } from "vue-property-decorator";

@Component({})
export default class FloatMenuAnimation extends Vue {
  openEmojiSelector() {
    const emoji = document.getElementsByClassName("emoji-selector-container");

    const emojiSelector = document.getElementById("emoji-selector");
    if (!emoji[0]) return;
    const width =
      window.innerWidth - (emojiSelector.getBoundingClientRect().left + 300);
    emoji[0]["style"].left =
      width > 0
        ? emojiSelector.getBoundingClientRect().left + "px"
        : emojiSelector.getBoundingClientRect().left - 274 + "px";
    emoji[0]["style"].opacity = "1";
  }
  closeEmojiSelector() {
    const emoji = document.getElementsByClassName("emoji-selector-container");
    if (!emoji[0]) return;
    emoji[0]["style"].left = "4rem";
    emoji[0]["style"].opacity = "0";
  }

  openChangeSpaceSelector() {
    const emoji = document.getElementsByClassName("change-space-selector-container");
    if (!emoji[0]) return;
    emoji[0]["style"].left = "3rem";
    emoji[0]["style"].opacity = "1";
  }
  
  closeChangeSpacenSelector() {
    const emoji = document.getElementsByClassName("change-space-reason-selector-container");
    if (!emoji[0]) return;
    emoji[0]["style"].left = "4rem";
    emoji[0]["style"].opacity = "0";
  }

  openReasonSelector() {
    const emoji = document.getElementsByClassName("reason-selector-container");
    if (!emoji[0]) return;
    emoji[0]["style"].left = "3rem";
    emoji[0]["style"].opacity = "1";
  }
  closeReasonSelector() {
    const emoji = document.getElementsByClassName("reason-selector-container");
    if (!emoji[0]) return;
    emoji[0]["style"].left = "4rem";
    emoji[0]["style"].opacity = "0";
  }

  openCallMenu() {
    const icon = document.getElementById("menu-actions");
    const callMenu = document.getElementById("more-actions-menu");
    const callActionContainer = document.getElementById(
      "call-actions-container"
    );
    if (!callMenu) return;
    const offSet =
      icon.getBoundingClientRect().left -
      callActionContainer.getBoundingClientRect().left;
    callMenu["style"].display = "block";
    setTimeout(() => {
      callMenu["style"].opacity = "1";
      callMenu["style"].left = 32 + (offSet - 48) + "px";
    }, 200);
  }

  closeCallMenu() {
    const callMenu = document.getElementById("more-actions-menu");
    if (!callMenu) return;

    callMenu["style"].left = "4rem";
    callMenu["style"].opacity = "0";
    setTimeout(() => {
      callMenu["style"].display = "none";
    }, 200);
  }

  openRecordOptions() {
    const recordOption = document.getElementById("record-options-container");
    if (!recordOption) return;
    recordOption["style"].opacity = "1";
    recordOption["style"].left = "7.5rem";
  }
  closeRecordOptions() {
    const recordOption = document.getElementById("record-options-container");
    if (!recordOption) return;
    recordOption["style"].opacity = "0";
    recordOption["style"].left = "-200px";
  }

  openUsersInCall() {
    const usersInCall = document.getElementById("users-in-call-container");
    if (!usersInCall) return;

    usersInCall["style"].display = "block";
    setTimeout(() => {
      usersInCall["style"].opacity = "1";
      usersInCall["style"].left = "50px";
    }, 200);
  }
  closeUsersInCall() {
    const usersInCall = document.getElementById("users-in-call-container");
    if (!usersInCall) return;
    usersInCall["style"].opacity = "0";
    usersInCall["style"].left = "-200px";
    setTimeout(() => {
      usersInCall["style"].display = "none";
    }, 200);
  }

  openLayoutTypes() {
    const usersInCall = document.getElementById("layout-types-container");
    if (!usersInCall) return;

    usersInCall["style"].display = "block";
    setTimeout(() => {
      usersInCall["style"].opacity = "1";
      usersInCall["style"].left = "0rem";
    }, 200);
  }
  closeLayoutTypes() {
    const usersInCall = document.getElementById("layout-types-container");
    if (!usersInCall) return;
    usersInCall["style"].opacity = "0";
    usersInCall["style"].left = "-200px";
    setTimeout(() => {
      usersInCall["style"].display = "none";
    }, 200);
  }

  openAudioMenu() {
    const icon = document
      .getElementsByClassName("audio-menu-icon")
      .item(0) as HTMLElement;
    const callMenu = document.getElementById("audio-menu");
    const callActionContainer = document.getElementById(
      "call-actions-container"
    );
    if (!callMenu) return;
    const offSet =
      icon.getBoundingClientRect().left -
      callActionContainer.getBoundingClientRect().left;
    callMenu["style"].display = "block";
    setTimeout(() => {
      callMenu["style"].opacity = "1";
      callMenu["style"].left = 32 + (offSet - 48) + "px";
    }, 200);
  }
  closeAudioMenu() {
    const callMenu = document.getElementById("audio-menu");
    if (!callMenu) return;

    callMenu["style"].left = "4rem";
    callMenu["style"].opacity = "0";
    setTimeout(() => {
      callMenu["style"].display = "none";
    }, 200);
  }

  openVideoMenu() {
    const icon = document
      .getElementsByClassName("video-menu-icon")
      .item(0) as HTMLElement;
    const callMenu = document.getElementById("video-menu");
    if (!callMenu) return;
    const callActionContainer = document.getElementById(
      "call-actions-container"
    );
    const offSet =
      icon.getBoundingClientRect().left -
      callActionContainer.getBoundingClientRect().left;
    callMenu["style"].display = "block";
    setTimeout(() => {
      callMenu["style"].opacity = "1";
      callMenu["style"].left = 32 + (offSet - 48) + "px";
    }, 200);
  }
  closeVideoMenu() {
    const callMenu = document.getElementById("video-menu");
    if (!callMenu) return;

    callMenu["style"].left = "4rem";
    callMenu["style"].opacity = "0";
    setTimeout(() => {
      callMenu["style"].display = "none";
    }, 200);
  }
}
